<template>
  <div id="teamInfo" > <!-- v-loading="loading" -->
    <v-header title="团队信息"></v-header>
    <div class="conH"></div>
    <div class="main-div">
      <el-row type="flex" class="title" justify="center">
        <el-col :span="24">
          <div>
            <span class="topLeft">团队信息</span>
          </div>
        </el-col>
      </el-row>

    <div class="bigInput">
      <el-input placeholder="请输入内容" v-model="input" class="input-with-select">
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="姓名" value="1"></el-option>
          <el-option label="业务编码" value="2"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="searchAgent"></el-button>
      </el-input>
   </div>
    <div class="middleDataTable" >

          <el-table
            :data="teamPersons"
            style="width: 100"
            :border="false"
            :fit="true"
            >
            <el-table-column
                prop="agentId"
                label="业务编码"
                min-width="120"
                align="center"
                >
            </el-table-column>
            <el-table-column
                prop="agentName"
                label="姓名"
                min-width="100"
                >
            </el-table-column>
            <el-table-column
                prop="rankName"
                label="职级"
                min-width="180">
            </el-table-column>

             <el-table-column
                prop="cltNum"
                label="客户数量"
                min-width="100"
                >
            </el-table-column>
             <el-table-column
                prop="pi"
                label="保费总和"
                min-width="100"
                >
            </el-table-column>

             <el-table-column
                prop="polocyNum"
                label="有效保单数"
                min-width="100"
                >
            </el-table-column>

            <el-table-column
                prop="polocyPi"
                label="件均保费"
                min-width="100">
            </el-table-column>

          </el-table>
      </div>

       <el-row type="flex" class="row-bg" justify="center">
            <el-col class="pages">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next, jumper"
                :total="itemCount">
            </el-pagination>
            </el-col>

      </el-row>

    </div>
  </div>
</template>

<script>
import api from '@/modules/api'
import url from '@/modules/url'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      // loading: null,
      select: '1',
      input: '',
      req: {
        agentNum: '',
        agenetName: '',
        level: '',
        startIndex: '0',
        limit: '10',
        orderBy: ''
      },
      searchReq: {
        LEVEL: '',
        AGENTNUM: '',
        AGENTNAME: '',
        TEAMCODE: '',
        startIndex: '0',
        limit: '10'
      },
      itemCount: 0,
      currentPage: 1,
      teamCode: '',
      teamPersons: []
    }
  },
  mounted () {
    this.initReq()
  },
  created () {

  },
  watch: {
    '$route': 'initReq'
  },
  methods: {
    searchAgent () {
       const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      let that = this

      if (that.input === '') {
        this.req.agentNum = this.$route.params.agentNum
        loading.close();
        that.search()
      } else {
        if (that.select === '1') {
          that.searchReq.AGENTNAME = that.input
          that.searchReq.LEVEL = that.searchReq.TEAMCODE.substring(0, 1)
          api.post(url.getTeamPersonInfo, that.searchReq, function (res) {
            loading.close();
            that.itemCount = res.data.data.length
            that.teamPersons = that.teamPersons = res.data.data
          })
        } else {
          that.req.startIndex = '0'
          that.req.agentNum = that.input
          that.req.level = 'R'
          api.post(url.getTeamInfo, this.req, function (res) {
            loading.close();
            that.itemCount = res.data.data.itemCount - 0
            that.teamPersons = res.data.data.teamPersons
          })
        }
      }
    },
    search () {
      // this.loading = true
       const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      let that = this
      this.req.agentNum = this.$route.params.pid
      that.req.level = that.teamCode.substring(0, 1)
      api.post(url.getTeamInfo, this.req, function (res) {
        that.teamPersons = []
        that.itemCount = res.data.data.itemCount - 0
        that.teamPersons = res.data.data.teamPersons
        that.loading = false
        loading.close();
      })
    },
    handleCurrentChange (val) {
      // 改变分页参数
      this.currentPage = val
      this.req.startIndex = (this.currentPage - 1) * this.req.limit + ''
      this.search()
    },
    initReq () {
      this.req.agentNum = this.$route.params.pid
      this.teamCode = this.$route.params.teamCode
      this.searchReq.TEAMCODE = this.$route.params.teamCode
      this.search()
    }
  }
}

</script>

<style scoped>
.main-div{
  margin: 20px;
}
.topLeft{
  float: left;
}
.topRight{
    float: right;
    /* width: 10%;
    height: 30px; */
}
.middleDataTable{
  /* box-shadow: 1px 2px 5px 1px rgba(1, 1, 1, 0.3); */
  -webkit-box-flex: 1;
  box-sizing: border-box;
}

.text::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color:#f2f2f2;
}

.el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid transparent !important;
}

.el-table thead {
    color: red;
    font-weight: 500;
}

.bigInput{
  margin-bottom: 20px;
  text-align: center;
}

.el-select {
    width: 120px;
  }

.el-button{
  width: 70px;
}

.input-with-select {
  width: 60%;
}
.pages{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #ffffff;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/teamInfo.vue